module.exports = __webpack_public_path__ + "img/16.b3a31327.jpg";